import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-echarts",
  "use": "icon-echarts-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-echarts\"><path d=\"M75.093 75.093h72.818v873.813h-72.818zM293.637 512h72.818v291.271h-72.818zM584.909 439.182h72.818v364.089h-72.818zM730.544 220.729h72.818v582.542h-72.818zM439.274 367.365h72.818v435.905h-72.818z\" p-id=\"5501\" /><path d=\"M74.911 948.907v-72.818h873.813v72.818z\" p-id=\"5502\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol